import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    longText: {
      wordBreak: "break-all",
    },
    form: {
      maxWidth: 400,
      margin: [10, "auto"],
    },
    emailPlaceholder: {
      margin: [10, "auto"],
    },
  }),
  { name: "ChangeEmail" },
);
